
import {PermissionsModel} from 'src/app/modules/common/entity/permissions.model';
import {UserSummary} from "src/app/modules/account/modules/user/api/entity/userSummary.model";
import {SummaryModel} from "src/app/modules/common/entity/summary.model";

export class CommunicationConfigurationEmailSenderSummaryModel implements SummaryModel {
    id: number;
    label: string;
    owner: UserSummary;
    permissions: PermissionsModel;

}